// Returns true when `query` is empty or any provided value contains it (case-insensitive).
// Used to filter the Pending/Completed task tables "by any coincidence" across columns.
export const matchesSearch = (values, query) => {
  if (!query) return true;
  const q = query.toLowerCase();
  return values.some((v) => v != null && String(v).toLowerCase().includes(q));
};
